import noDataImg from '../../assets/image/noData.svg';

const NoData = ({text = 'موردی پیدا نشد'}: {text?: string}) => {
  return (
    <div className="flex flex-col items-center justify-center gap-3 max-w-60">
      <img src={noDataImg} alt="no data" className="w-28" />
      <span className="text-md text-gray-700 text-center leading-6">
        {text}
      </span>
    </div>
  );
};

export default NoData;
